export enum FIELD_NAMES {
  TOKEN = "token",
}

export const OTP_LENGTH = 6;
